import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import PasswordInput from './PasswordInput';

export const PasswordForm = ({ disabled, isNew }) => {
  const { trigger, watch } = useFormContext();
  const pwd = watch('pwd');
  const pwdConfirm = watch('pwdConfirm');
  useEffect(() => {
    if (pwd != null && pwd.trim() !== '' && pwdConfirm != null && pwdConfirm.trim() !== '') {
      trigger('pwdConfirm');
    }
  }, [pwd]);
  return (
    <>
      <PasswordInput
        disabled={disabled}
        pwdName="pwd"
        label={i18n.t(isNew ? 'MB_T_ID_NEWPASS' : 'MB_T_COMMON_PASS')}
        placeholderLabel={i18n.t('MB_T_PW_HOLDER')}
      />
      <PasswordInput
        disabled={disabled}
        pwdName="pwdConfirm"
        placeholderLabel={i18n.t('MB_T_CPW_HOLDER')}
        label={i18n.t(isNew ? 'MB_T_ID_NEWPASS_CONFIRM' : 'MB_T_COMMON_JS_CONFIRMPASS')}
      />
    </>
  );
};
PasswordForm.propTypes = {
  disabled: PropTypes.bool,
  isNew: PropTypes.bool,
};
PasswordForm.defaultProps = { disabled: false, isNew: false };
PasswordForm.displayName = 'PasswordForm';
export default PasswordForm;
